<template>
  <el-form :inline="true" ref="form" class="form" :class="{active: isShow}" :model="form">
    <el-form-item :label="item.label" :key="i" v-for="(item, i) in items">
      <!-- //todo search has bug -->
      <!-- <el-checkbox-group v-if="item.type === 'checkbox'" v-model="form[item.prop]">
        <el-checkbox v-for="dic in item.dicData" :label="dic.value" :key="dic.value" :disabled="disabled">{{dic.label}}</el-checkbox>
      </el-checkbox-group> -->
      <template v-if="item.type === 'radio'">
        <el-radio v-for="dic in item.dicData" :label="dic.value" :key="dic.value" v-model="form[item.prop]"
          :disabled="disabled">{{dic.label}}</el-radio>
      </template>

      <el-select v-else-if="item.type === 'select' || item.type === 'checkbox'" v-model="form[item.prop]"
        :placeholder="`请选择${item.label}`">
        <el-option v-for="item in item.dicData" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-input v-else v-model="form[item.prop]" />
    </el-form-item>
    <el-form-item>
      <el-button style="margin-left:0!important" size="small" type="primary" icon="el-icon-search"
        @click="onSubmit">搜索</el-button>
      <el-button size="small" icon="el-icon-delete" @click="onClear">清空</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import _ from 'lodash'
import mixinRowInit from './components/mixins/rowInit'
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixinRowInit],
  data() {
    return {
      form: this.initFormData()
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {

  },
  methods: {
    onSubmit() {
      const obj = {}
      for (let [k, v] of Object.entries(this.form)) {
        const emptys = [null, '']
        if (_.isArray(v) && !v.length) {
          continue
        }
        if (!emptys.includes(v)) {
          obj[k] = v
        }
      }
      this.$emit('on-submit', obj)
    },
    onClear() {
      this.form = this.initFormData()
      this.$emit('on-clear', {})
    },
    initFormData() {
      let obj = {}
      obj = this.initRow(obj)
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  transition: height 1s;
  -moz-transition: height 1s;
  -webkit-transition: height 1s;
  -o-transition: height 1s;
  width: 100%;
  box-sizing: border-box;
  padding-left: 50px;
  overflow: hidden;
  display: none;
  opacity: 0;
  &.active {
    display: block;
    opacity: 1;
  }
}
.el-form-item {
  margin-bottom: 10px;
}
:deep(.el-form-item__label) {
  width: auto !important;
}
</style>
